import {getIn, useFormikContext} from "formik";
import {Form} from "react-bootstrap";

const FormSwitch = ({ name, label, id }) => {
    const { values, setFieldValue } = useFormikContext();

    const checked = getIn(values, name) ?? false;

    return (
        <Form.Check
            checked={checked}
            onChange={(e) => setFieldValue(name, e.target.checked)}
            name={name}
            type="switch"
            id={name.replace(/\./g, '')}
            label={label}
        />
    );
}

export default FormSwitch
